import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: !window.location.href.includes("test")
    ? process.env.REACT_APP_API_URL
    : "https://apitest.glassen-it.com/component/socparser/",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("access");

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const topicsApi = createApi({
  reducerPath: "topics",
  baseQuery: baseQueryWithAuth,
  endpoints: ({ query }) => ({
    topics: query({
      query: (body) => ({
        url: "stats/getReferenceSourceTopics",
        method: "post",
        credentials: "include",
        body,
      }),
    }),
    refSources: query({
      query: (body) => ({
        url: "inpd/getRefSources",
        method: "post",
        credentials: "include",
        body,
      }),
    }),
    topicRating: query({
      query: () => ({
        url: "inpd/getTopicRating",
        method: "get",
        credentials: "include",
      }),
    }),
    topicRatingShortRange: query({
      query: () => ({
        url: "inpd/getTopicRatingShortRange",
        method: "get",
        credentials: "include",
      }),
    }),
    topicsModal: query({
      query: (body) => ({
        url: "content/getTopic",
        method: "post",
        credentials: "include",
        body,
      }),
    }),
    smi: query({
      query: () => ({
        url: "content/currentsmi",
        method: "post",
        credentials: "include",
      }),
    }),
    mainTopic: query({
      query: (body) => ({
        url: "stats/getMainTopics",
        method: "post",
        credentials: "include",
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useTopicsQuery, useRefSourcesQuery, useTopicRatingQuery, useTopicRatingShortRangeQuery,  useTopicsModalQuery, useSmiQuery, useMainTopicQuery } = topicsApi;
